import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

export const usePBJCodeColumn = () => {
    const { t } = useTranslation();

    return useMemo(() => {
        return {
            Header: t("PBJ-code"),
            accessor: "pbjCode",
            alwaysVisible: false,
            disableFilters: false,
            Cell: ({ row }) => {
                const pbjCode = /**row.original?.pbjCode || */ row.original?.job?.pbjCode;
                return renderSettingsResourceLabel(pbjCode);
            }
        }
    }, [t])
}